<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t("ADMISSION_DATA.IMAGE_ATTACHED") }}
        </v-card-title>

        <v-card-text class="py-5">

           <LightGallery
            :images="[src]"
            :index="index"
            :disable-scroll="true"
            @close="index = null"
          />

          <div style="cursor: zoom-in;"
            v-for="(thumb, thumbIndex) in [
              src
            ]"
            :key="thumbIndex"
            @click="index = thumbIndex"
          >
            <v-img  :src="thumb" aspect-ratio="1.4" contain>
            </v-img>
          </div>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            {{ $t("CLOSE") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import { LightGallery } from 'vue-light-gallery';
export default {
  name: "ad-show-files",
  props: ["src","on"],
  components: {
    LightGallery
  },
  data() {
    return {
      dialog: false,
      index:null
    };
  },
  created() {
    this.dialog =true;
  },
  watch:{
      dialog(){
          this.on = this.dialog;
      },
      on(newVal){
          this.dialog = newVal;
          if(!this.dialog)
              this.$emit("close");
      }
  }
};
</script>
